// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-container {
  padding: 2%;
  font-family: Arial, sans-serif;
}

.admin-container h2 {
  padding: 1% 0;
  color: #333;
  text-align: left;
  margin: 0 0 3% 0;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 2%;
  overflow-x: auto;
}

.filters > div,
.filters > button {
  flex-shrink: 0;
  white-space: nowrap;
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 20px;
}

.date-filter label {
  font-size: medium;
  font-weight: bold;
  margin: 0px;
}

.date-filter input {
  max-width: 150px;
  padding: 2%;
  border-radius: 5px;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 2%;
  white-space: nowrap;
  margin: 0px;
  padding: 0px;
}

.search-bar label {
  font-size: medium;
  font-weight: bold;
  white-space: nowrap;
  margin: 0px;
}

.search-bar input {
  flex: 1 1;
  padding: 3%;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 160px;
  margin-bottom: 0px;
}

.status-filter {
  display: flex;
  align-items: center;
  gap: 1%;
}

.status-filter label {
  margin-top: 5px;
  text-align: center;
  font-size: medium;
  font-weight: bold;
}

.status-filter select {
  width: 100px;
  padding: 4%;
  font-size: small;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
}

.leave-table-container {
  display: flex;
  justify-content: center;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: auto;
  margin: 2% 0;
}

.leave-table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

.leave-table td {
  border: 1px solid #cccbce;
  background-color: #fff;
  padding: 0.5%;
  text-align: left;
  font-size: 15px;
}

.leave-table th:nth-child(7),
.leave-table td:nth-child(7) {
  min-width: 50px;
  text-align: center;
}

.leave-table th {
  top: 0;
  border: 2px solid #cccbce;
  background-color: #f2f2f2;
  padding: 1% 0;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.leave-table tr:hover {
  background-color: #f1f1f1;
}

.status-dropdown {
  padding: 4%;
  border-radius: 4px;
  border: 2px solid #ccc;
  font-size: small;
  color: #000;
  text-align: center;
  cursor: pointer;
}

.status-dropdown option[value="Approved"],
.status-dropdown[value="Approved"] {
  background-color: #d7f2ce;
  color: #000;
}

.status-dropdown option[value="Rejected"],
.status-dropdown[value="Rejected"] {
  background-color: #ffe5d2;
  color: #000;
}

.status-approved {
  background-color: #d7f2ce;
  color: #000;
}

.status-rejected {
  background-color: #ffe5d2;
  color: #000;
}

.search-button {
  padding: 0.6%;
  margin-left: 2%;
  font-size: medium;
  cursor: pointer;
  width: 10%;
  background-color: #00468c;
  color: white;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.search-button:hover {
  background-color: #003a70; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.search-button:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.search-button:focus {
  outline-offset: 2px;
}

.update-button {
  background-color: #7fbd2c;
  color: white;
  border: none;
  padding: 5px 15px;
  font-size: small;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
  height: 30px;
}

.update-button.row-updated {
  background-color: #d3d3d3;
  color: #555;
}

.update-button:hover {
  background-color: #218838;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.update-button:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.update-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.disabled-button {
  background-color: #d3d3d3 !important;
  color: #000 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  border: none !important;
}

.leave-table th.comments-col,
.leave-table td.comments-col {
  width: 200px;
  vertical-align: top;
}

.comment-preview input {
  width: 85%;
  padding: 4%;
}

.comment-preview {
  max-height: 35px;
  overflow: hidden;
  transition: max-height 0.3s ease;
  white-space: normal;
  text-overflow: ellipsis;
  word-wrap: break-word;
  font-size: medium;
}

.comments-col:hover .comment-preview {
  max-height: 1000px;
}

/* Responsive design */
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .search-bar {
    flex-wrap: wrap;
  }

  .search-bar select,
  .search-bar input,
  .search-bar button {
    margin-bottom: 10px;
    width: 100%;
  }

  table th,
  table td {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LeaveQueries/Admin.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;wBACsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".admin-container {\n  padding: 2%;\n  font-family: Arial, sans-serif;\n}\n\n.admin-container h2 {\n  padding: 1% 0;\n  color: #333;\n  text-align: left;\n  margin: 0 0 3% 0;\n}\n\n.filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  margin-bottom: 2%;\n  overflow-x: auto;\n}\n\n.filters > div,\n.filters > button {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.date-filter {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.date-filter label {\n  font-size: medium;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.date-filter input {\n  max-width: 150px;\n  padding: 2%;\n  border-radius: 5px;\n}\n\n.search-bar {\n  display: flex;\n  align-items: center;\n  gap: 2%;\n  white-space: nowrap;\n  margin: 0px;\n  padding: 0px;\n}\n\n.search-bar label {\n  font-size: medium;\n  font-weight: bold;\n  white-space: nowrap;\n  margin: 0px;\n}\n\n.search-bar input {\n  flex: 1;\n  padding: 3%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 160px;\n  margin-bottom: 0px;\n}\n\n.status-filter {\n  display: flex;\n  align-items: center;\n  gap: 1%;\n}\n\n.status-filter label {\n  margin-top: 5px;\n  text-align: center;\n  font-size: medium;\n  font-weight: bold;\n}\n\n.status-filter select {\n  width: 100px;\n  padding: 4%;\n  font-size: small;\n  font-weight: bold;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-top: 5px;\n}\n\n.leave-table-container {\n  display: flex;\n  justify-content: center;\n  max-height: 600px;\n  overflow-y: auto;\n  overflow-x: auto;\n  margin: 2% 0;\n}\n\n.leave-table {\n  table-layout: fixed;\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.leave-table td {\n  border: 1px solid #cccbce;\n  background-color: #fff;\n  padding: 0.5%;\n  text-align: left;\n  font-size: 15px;\n}\n\n.leave-table th:nth-child(7),\n.leave-table td:nth-child(7) {\n  min-width: 50px;\n  text-align: center;\n}\n\n.leave-table th {\n  top: 0;\n  border: 2px solid #cccbce;\n  background-color: #f2f2f2;\n  padding: 1% 0;\n  font-weight: bold;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.leave-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n.status-dropdown {\n  padding: 4%;\n  border-radius: 4px;\n  border: 2px solid #ccc;\n  font-size: small;\n  color: #000;\n  text-align: center;\n  cursor: pointer;\n}\n\n.status-dropdown option[value=\"Approved\"],\n.status-dropdown[value=\"Approved\"] {\n  background-color: #d7f2ce;\n  color: #000;\n}\n\n.status-dropdown option[value=\"Rejected\"],\n.status-dropdown[value=\"Rejected\"] {\n  background-color: #ffe5d2;\n  color: #000;\n}\n\n.status-approved {\n  background-color: #d7f2ce;\n  color: #000;\n}\n\n.status-rejected {\n  background-color: #ffe5d2;\n  color: #000;\n}\n\n.search-button {\n  padding: 0.6%;\n  margin-left: 2%;\n  font-size: medium;\n  cursor: pointer;\n  width: 10%;\n  background-color: #00468c;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.search-button:hover {\n  background-color: #003a70; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.search-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.search-button:focus {\n  outline-offset: 2px;\n}\n\n.update-button {\n  background-color: #7fbd2c;\n  color: white;\n  border: none;\n  padding: 5px 15px;\n  font-size: small;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n  height: 30px;\n}\n\n.update-button.row-updated {\n  background-color: #d3d3d3;\n  color: #555;\n}\n\n.update-button:hover {\n  background-color: #218838;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.update-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.update-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.disabled-button {\n  background-color: #d3d3d3 !important;\n  color: #000 !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n  border: none !important;\n}\n\n.leave-table th.comments-col,\n.leave-table td.comments-col {\n  width: 200px;\n  vertical-align: top;\n}\n\n.comment-preview input {\n  width: 85%;\n  padding: 4%;\n}\n\n.comment-preview {\n  max-height: 35px;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  white-space: normal;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n  font-size: medium;\n}\n\n.comments-col:hover .comment-preview {\n  max-height: 1000px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n\n  .search-bar {\n    flex-wrap: wrap;\n  }\n\n  .search-bar select,\n  .search-bar input,\n  .search-bar button {\n    margin-bottom: 10px;\n    width: 100%;\n  }\n\n  table th,\n  table td {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
